// extracted by mini-css-extract-plugin
export default {"loading-overlay":"GlobalLoadingSpinner_loading-overlay__RDmsR","spinner":"GlobalLoadingSpinner_spinner__L+VJ3","spin":"GlobalLoadingSpinner_spin__Cgczg"};